import Vue from 'vue'
import L from 'leaflet'

function intersectBounds(b1, b2) {
  return !(b1._southWest.lat > b2._northEast.lat || b1._northEast.lat < b2._southWest.lat || b1._southWest.lng > b2._northEast.lng || b1._northEast.lng < b2._southWest.lng);
}

function boundsCenter(bounds) {
  return L.latLng(b._)
}

export default function createApp(lmap, geoJsonLayers, fieldName) {
  fieldName = fieldName || "name"
  const appEl = document.getElementById('app');
  if (!appEl) return;
  const vueApp = new Vue({
    el: '#app',
    data: {
      results: [],
      term: '',
      resultsCount: ''
    },
    created: function () {
      this.resultsLayer = L.featureGroup([]);
    },
    methods: {
      findPlace: function (features, text, limit, inBounds, bounds) {
        const results = []
        this.resultsLayer.clearLayers();
        for (let i = 0; i < features.length && results.length < limit; i++) {
          const feature = features[i];
          if (feature.lowerName.startsWith(text) && (!inBounds || intersectBounds(bounds, feature.bounds))) {
            results.push(feature);
          }
        }
        results.forEach(r => {
          L.circleMarker(r.bounds.getCenter(), { radius: 3, color: 'black', fillColor: 'black' }).
            addTo(this.resultsLayer);
          if (results.length < 30) {
            this.getLeafletObj(r.l_id).openTooltip();
          }
        })
        this.resultsCount = results.length
        return results.sort((x, y) => x.name.localeCompare(y.name));
      },
      setCurrentLayer: function () {
        const gjl = this.layers.find(l => this.map.hasLayer(l))
        this.currentLayer = gjl
      },
      search: function (term, inMap) {
        this.term = term;
        this.resultsLayer.addTo(this.map);
        this.resultsLayer.clearLayers();
        const lowerTerm = term.toLowerCase();
        this.results.forEach(r => {
          if (this.results.length < 30 && this.currentLayer) {
            if (this.getLeafletObj(r.l_id)) {
              this.getLeafletObj(r.l_id).closeTooltip();
            }
          }
        })
        this.resultsLayer.clearLayers();
        if (lowerTerm === '') {
          this.resultsCount = ''
          this.results = []
          return;
        }
        if (this.currentLayer) {
          const summ = this.layerSumm.find(ls => ls.l_id === this.currentLayer._leaflet_id)
          this.results = this.findPlace(summ.features, lowerTerm, 1000, inMap, this.map.getBounds())
        }
      },
      getLeafletObj: function (id) {
        if (!this.currentLayer) debugger;
        return this.currentLayer.getLayers()[0].getLayer(id);
      },
      highlight: function (e) {
        const feature = this.getLeafletObj(Number(e.target.dataset.leafletId));
        console.log('Highlight',feature.getTooltip().isOpen())
        if (!feature.getTooltip().isOpen()) feature.getTooltip().toggle();
        if (feature.getTooltip()._contentNode) feature.getTooltip()._contentNode.classList.add('highlight')
        this.lastColor = feature.options.fillColor;
        if (feature.setStyle) feature.setStyle({ fillColor: 'black' });
      },
      undoHighlight: function (e) {
        const feature = this.getLeafletObj(Number(e.target.dataset.leafletId));
        console.log('Undo',feature.getTooltip().isOpen())
        if (feature.getTooltip().isOpen()) feature.getTooltip().toggle();

        if (feature.getTooltip()._contentNode) feature.getTooltip()._contentNode.classList.remove('highlight')
        if (feature.setStyle) feature.setStyle({ fillColor: this.lastColor });
      },
      zoomTo: function (e) {
        const feature = this.getLeafletObj(Number(e.target.dataset.leafletId));
        this.map.flyToBounds(feature.getBounds());
      },
      setupEvents: function (e) {
        this.setCurrentLayer();
        this.map.on('overlayadd', (e) => {
          this.setCurrentLayer();
          this.search(this.term);
        });
        this.map.on('overlayremove', () => {
          this.setCurrentLayer();
          this.search(this.term);
        })

      }
    },
    computed: {
      layerSumm: function () {
        return this.layers.map(function (fg) {
          const l = fg.getLayers()[0];
          return {
            l_id: fg._leaflet_id,
            features: l.getLayers().map(f => {
         //     if (typeof f.feature.getBounds === 'undefined') debugger;
              var bounds = (f.feature.geometry.type === 'Point') ? L.latLngBounds(f.getLatLng(), f.getLatLng()) : f.getBounds(); 
              return {
                l_id: f._leaflet_id,
                name: f.feature.properties[fieldName] ? f.feature.properties[fieldName] : '',
                lowerName: f.feature.properties[fieldName] ? f.feature.properties[fieldName].toLowerCase() : '',
                bounds: bounds
              }
            })
          }
        })
      }
    },
    template: `
    <div class="search-form">
      <search-form @search="search" class="search-input" :resultsCount="resultsCount"/>
      <ul class="search-results" v-if="results.length>0">
        <li v-for="entry in results" :data-leaflet-id="entry.l_id" @mouseover="highlight" @mouseout="undoHighlight" @click="zoomTo">{{entry.name}}</li> 
      </ul>
    </div>`
  })
  vueApp.layers = geoJsonLayers;
  vueApp.map = lmap;
  vueApp.setupEvents();

}
